/** Decode bytes without the intermediate per-character array used by Uint8Array.from. */
export function bytesFromBinaryString(binary: string): Uint8Array {
  const bytes = new Uint8Array(binary.length);
  for (let index = 0; index < binary.length; index++)
    bytes[index] = binary.charCodeAt(index);
  return bytes;
}

export function bytesFromBase64(encoded: string): Uint8Array {
  return bytesFromBinaryString(atob(encoded));
}
